export const SLIDER_SETTINGS = {
  infinite: false,
  dots: true,
  arrows: false,
  slidesToScroll: 1,
  slidesToShow: 1,
};

export const REVIEWS_SLIDER_SETTINGS = {
  slidesToShow: 2,
  swipeToSlide: true,
  infinite: false,
  arrows: false,
  responsive: [
    {
      breakpoint: 780,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};
